/**
 * 跳转兼容插件
 */
import warn from '@/libs/base/warn'

const PATH_MAP = {
  barrage: 'barrage',
  '/thunder/expression': 'expression',
  expression: 'expression',
  '/thunder/mv': 'mv',
  mv: 'mv',
  bless: 'bless',
  photo: 'photo',
  '/thunder/gift': 'gift',
  gift: 'gift',
  'dp-doutu': 'doutu',
  '/thunder/blessv1': 'common',
  '/thunder/bless_pag1/2': 'common',
  '/thunder/bless_sort/1': 'common',
  '/thunder/bless_sort/4': 'common',
  aigc: 'aigc',
}

const TargetPathHandlerMap = {
  common({
 store, path, router, fromType
}) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    router.push(`${path}?fromType=${fromType}`)
  },
  aigc({
 store, path, fromType, router
}) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    if (store.state.supportPAG) {
      router.push(`${path}?fromType=${fromType}`)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },
  barrage({ store }) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    if (store.state.have_bullet) {
      store.commit('SHOW_BARRAGE', true)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },
  expression({ path, router, store }) {
    if (store.state.have_emoji) {
      router.push(path)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },

  mv({
 path, router, store, fromType
}) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    if (store.state.have_mv) {
      router.push(`${path}?fromType=${fromType}`)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },
  bless({ fromType, router, store }) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    router.push(`${store.state.bless_path}?fromType=${fromType}`)
  },
  photo({ router, store, fromType }) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    if (store.state.have_photo) {
      const photopath = `${store.state.photo_path}?fromType=${fromType}`
      router.push(photopath)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },
  doutu({ router, store, fromType }) {
    if (store.state.isBlockInteractText) {
      return this.$messageBox.alert(warn.noSupport, '')
    }
    if (store.state.have_photo) {
      const url = store.state.photo_path.includes('pag')
        ? '/thunder/photov2'
        : store.state.photo_path
      const doutupath = `${url}_doutu?fromType=${fromType}`
      router.push(doutupath)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },
  gift({
 path, router, store, fromType
}) {
    if (store.state.have_gift) {
      router.push(`${path}?fromType=${fromType}`)
      // store.commit('SHOW_GIFT_CONTROL', true)
    } else {
      this.$messageBox.alert(warn.noSupport, '')
    }
  },
}

function defaultHandler({
 path, fromType, router, store
}) {
  const symbol = path.includes('?') ? '&' : '?'
  if (path.indexOf('http') >= 0) {
    window.location.href = path
    return
  }
  // 解决/c0/view/home接口返回数据，导致首页icon「我要表白」与版本不统一的问题
  if (
    path.includes('blessv1')
    && window.location.href.includes('/thunder/home')
  ) {
    router.push(`${store.state.bless_path}?fromType=${fromType}`)
    return
  }
  if (path.includes('fromType')) {
    router.push(path)
  } else {
    router.push(`${path}${symbol}fromType=${fromType}`)
  }
}

export default {
  install(Vue, { router, store }) {
    Vue.prototype.$jump = (path, fromType) => {
      // 逻辑...
      const pathSymbol = PATH_MAP[path]
      const targetPathHandler = TargetPathHandlerMap[pathSymbol]
      const params = {
        path,
        fromType,
        router,
        store,
      }
      console.log('PathJumpSeparation:', params, targetPathHandler || 'default')
      if (targetPathHandler) {
        targetPathHandler.call(Vue, params)
      } else {
        // default
        defaultHandler.call(Vue, params)
      }
    }
  },
}
